window.addEventListener('load', () => {
  const modal = document.getElementById('sizeGuideModal');
  const openBtn = document.getElementById('size-guide-trigger');
  const closeBtn = document.getElementById('closeSizeGuide');

  // Only proceed if modal exists
  if (!modal) {
    return;
  }

  if (openBtn) {
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.showModal();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.close();
    });
  }

  // Add click outside to close functionality
  modal.addEventListener('click', (e) => {
    const rect = modal.getBoundingClientRect();
    if (
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom
    ) {
      modal.close();
    }
  });
});
